<template>
  <div id="app">
    <component :is="viewComponent"
               :msg="errorMessage"
               :uniqueID="uniqueID"/>
  </div>
</template>

<script>
//import config from "./config/config.js";
//import functions from "./lib/functions.js";
//import libConst from "./lib/libConst.js";
import IWPlayer from "./components/IWPlayer.vue";
import IWError from "./components/IWError.vue";

export default {
  name: "iWPlayer",
  data: function () {
    return {
      errorMessage: "",
      uuidValid: false,
      uniqueID: "",
    };
  },
  components: {
    IWPlayer,
    IWError,
  },
  computed: {
    viewComponent: function () {
      let comp = undefined;

      if (this.uuidValid) {
        comp = IWPlayer;
      } else {
        comp = IWError;
      }

      return comp;
    },
  },
  created() {
    var pathname = window.location.pathname;
    var pathElements = pathname.replace(/\/$/, "").split("/");
    var uniqueID = pathElements[pathElements.length - 1];

    var paramsSearch = new URLSearchParams(window.location.search);
    let uniqueIDArgGet = paramsSearch.get("uniqueID");
    if (uniqueIDArgGet) {
      this.uniqueID = uniqueIDArgGet;
    } else {
      this.uniqueID = uniqueID;
    }
    if (this.uniqueID) {
      //check type uniqueID
      if (this.uniqueID.substring(0, 4).toLowerCase() === 'vod_') {
        this.uniqueID = this.uniqueID.substring(4);
        uniqueID = this.uniqueID;
        this.$store.commit("setUniqueIDType", 'vod');
      }
      this.$store.commit("setUniqueID", this.uniqueID);
    }
    if (this.uniqueID != "") {
      this.uuidValid = true;
    } else {
      this.errorMessage = "Event ID is empty";
      this.uuidValid = false;
    }
    let cur_lang = paramsSearch.get("lang");
    if (cur_lang) {
      this.$store.commit("set_cur_lang", cur_lang);
    }
    let def_lang = paramsSearch.get("def_lang");
    if (def_lang) {
      this.$store.commit("set_def_lang", def_lang);
    }
    let userID = paramsSearch.get("userID");
    if (userID) {
      this.$store.commit("setUserID", userID);
    }
    let previewToken = paramsSearch.get("preview_token");
    if (previewToken) {
      this.$store.commit("setPreviewToken", previewToken);
    }
    let disable_check_cuepoints = paramsSearch.get("disable_check_cuepoints");
    if (disable_check_cuepoints) {
      this.$store.commit("set_disable_check_cuepoints", disable_check_cuepoints == 'true' ? true : false);
    }
    let videodebug = paramsSearch.get("p2p_debug");
    if (videodebug) {
      this.$store.commit("setVideodebug", videodebug === 'true' ? true : false);
    }
  },
  mounted() {
  },
  updated() {
  },
  unmounted() {
  },
  methods: {},
};
</script>

<style>
* {
  margin: 0;
}

html,
body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: auto;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*background-color: black;*/
  color: black;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: auto;
}
</style>
